// extracted by mini-css-extract-plugin
export default {"transfer-agreement__row":"styles_transfer-agreement__row__5heoK"};